import types from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';

export const reducers = {
  pcaQuery: createAsyncRequestReducer(types.PCA_QUERY_ANALYTICS),
  expressionQuery: createAsyncRequestReducer(types.EXPRESSION_QUERY_ANALYTICS),
  geneStatsQuery: createAsyncRequestReducer(types.GENE_STATS_QUERY_ANALYTICS),
  demographicsQuery: createAsyncRequestReducer(
    types.DEMOGRAPHIC_QUERY_ANALYTICS,
  ),
  query: createAsyncRequestReducer(types.QUERY_ANALYTICS),
  queryAsync: createAsyncRequestReducer(types.QUERY_ASYNC_ANALYTICS),
  insightsConfiguration: createAsyncRequestReducer(
    types.INSIGHTS_CONFIGURATION,
  ),
};

export default combineReducers(reducers);
